<AuthCard>
    <v-form ref="form" @submit.prevent="submit">
        <v-text-field
            variant="outlined"
            validate-on="blur"
            :label="emailData.label"
            :rules="emailData.rules"
            v-model="email"></v-text-field>
        <div class="d-flex justify-space-between">
            <v-btn
                type="submit"
                variant="flat"
                tile
                color="primary"
                :loading="loading">
                Request password reset
            </v-btn>
            <v-btn variant="text" @click="goToLoginPage">
                Back to login
            </v-btn>
        </div>
    </v-form>
    <BaseDialog
        label="Information"
        :width="300"
        v-model="informationDialog">
        <p>
            If a user with that email-address exists, an email containing
            the next step will be sent to it.
        </p>
        <v-btn color="primary" variant="flat" tile @click="goToLoginPage">
            Back to login
        </v-btn>
    </BaseDialog>
</AuthCard>